import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  //------View without data -------
  rootNoData: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#F7F8FC",
    color: theme.palette.grey.grey400,
    height: "224px",
    boxShadow: "inset 0px 4px 4px rgba(0, 0, 0, 0.03)",
    fontWeight: 400,
    fontSize: "14px",
  },
  noDataText: {
    fontFamily: "'Inter'",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "16px",
    color: theme.palette.grey.grey400,
    marginTop: "5px",
    marginBottom: "20px"
  },

  buttonWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  button: {
    padding: "6px 12px !important",
    marginBottom: "20px",
    marginLeft: "20px",
    width: "230px",
    height: "40px",
    boxShadow: "none"
  },
  buttonSmall: {
    padding: "0px 12px !important",
    marginBottom: "20px",
    width: "120px",
    height: "30px",
    boxShadow: "none"
  },
  buttonWithMargin: {
    marginLeft: "20px"
  },
  loadingChip: {
    width: "97px",
    height: "40px",
    borderRadius: "16px",
    fontFamily: "'Inter'",
    fontSize: "14px",
    lineHeight: "14px",
    paddingLeft: "4px"
  },
  buttonContent: {
    display: 'flex',
    gap: "5px",
    fontSize: "12px",
    alignItems: "center",
    color: theme.palette.primary.primary800,
  },
  buttonModifyContent: {
    display: 'flex',
    gap: "5px",
    fontSize: "12px",
    alignItems: "center",
    color: "white"
  },
  buttonStopContent: {
    display: 'flex',
    gap: "5px",
    fontSize: "12px",
    alignItems: "center",
    color: theme.palette.error.error600
  },
  infoIcon: {
    width: "25px"
  },
  owlinContent: {
    margin: "20px",
    maxHeight: "200px",
    overflowY: 'scroll'
  },
  formContainer: {
    display: "flex",
    margin: "5px"
  },
  inputGrid: {
    marginRight: "10px"
  },
  inputLabel: {
    color: theme.palette.grey.grey500,
    fontSize: "14px",
    fontWeight: 700,
    textAlign: "right",
  },
  tagsCaption: {
    fontSize: "12px",
    color: theme.palette.grey.grey400,
    fontWeight: 400
  },
  pendingWrapper: {
    marginTop: "60px"
  },
  pendingTitle: {
    color: theme.palette.grey.grey400,
    fontSize: "14px",
    fontWeight: 700,
    textAlign: "center",
    marginTop: "20px"
  },
  pendingSubTitle: {
    whiteSpace: "pre-line",
    color: theme.palette.grey.grey400,
    fontSize: "10px",
    fontWeight: 400,
    textAlign: "center"
  },
  pendingLoadingBar: {
    height: 10,
    width: "800px",
    margin: "auto",
    borderRadius: 5,
    "& .MuiLinearProgress-bar": {
      // apply a new animation-duration to the `.bar` class
      animationDuration: "6s",
      borderRadius: 5,
      backgroundColor: theme.palette.primary.primary600,
    },
    "& .MuiLinearProgress-bar2Indeterminate": {
      display: "none"
    },
    "&.MuiLinearProgress-colorPrimary": {
      backgroundColor: theme.palette.grey.grey200,

    }
  },
  failedBackButton: {
    cursor: "pointer"
  },
  failedIcon: {
    display: 'flex',
    justifyContent: 'center'
  },
  failedTitle: {
    whiteSpace: "pre-line",
    color: theme.palette.grey.grey400,
    fontSize: "18px",
    fontWeight: 600,
    textAlign: "center",
    marginTop: "20px"
  },
  failedSubTitle: {
    color: theme.palette.grey.grey400,
    fontSize: "10px",
    fontWeight: 400,
  },

  //Deactivation popup
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "8px",
  },
  imgContent: {
    width: "35px"
  },
  imgWrapper: {
    padding: "1rem",
    borderRadius: "50%",
    width: "55px",
    height: "55px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  imgWrapperRed: {
    backgroundColor: "#FFEBEB",
    marginBottom: "1rem",
  },
  imgWrapperGreen: {
    backgroundColor: theme.palette.primary.primary50
  },
  bolder: {
    fontWeight: 700,
    fontFamily: "Inter",
    fontSize: "18px",
    color: theme.palette.grey.grey700,
    width: "500px",
    textAlign: "center",
    whiteSpace: "pre-line"
  },
  caption: {
    color: theme.palette.grey.grey500,
    fontSize: "14px",
    textAlign: "center",
    marginTop: "10px"
  },
  leftAlignedTitle: {
    fontWeight: 600,
    fontFamily: "Inter",
    fontSize: "23px",
    color: theme.palette.grey.grey900,
    width: "500px",
    alignSelf: "flex-start",
    paddingBottom: "16px"
  },
  popupConfirmContainer: {
    display: "flex",
    alignItems: "center"
  },
  confirmCaption: {
    color: "#7E7E8F",
    fontSize: "14px",
    textAlign: "center",
    marginLeft: "10px"
  }
}));

export default useStyles;